module.exports = {"previous":"Boggii Hore","next":"Xiga &raquo;"};